'use client'

import { Icon, Image } from '@/components'
import { ButtonQuantityV2 } from '@/components/common/quantity/v2'
import { useVoucherStore } from '@/store/voucher'
import { getVND } from '@/utils/helpers'
import { Box, BoxProps, MenuItem, Select, Skeleton, Stack, StackProps, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { useMemo, useRef, useState } from 'react'
import { useProductDetailV2State } from '../../contexts/product-detail'
import { LocalIcon } from '../icon'
import { useSizeGuideContext } from '../../contexts/side-guide-context'
import SquareFootIcon from '@mui/icons-material/SquareFoot'
import { URL_ICON } from '@/constants/ui'
import { PriceDisplay } from './price-display'
const SPECIAL_INDEX = [3, 5, 6, 7, 8, 9, 10]
const listOption = Array.from({ length: 10 }).map((_, index) => ({
  label: (
    <Stack spacing={1} direction={'row'} alignItems={'center'}>
      <Typography color="inherit" sx={{ minWidth: '20px' }} fontSize={'14px'}>
        {index + 1}
      </Typography>{' '}
      {SPECIAL_INDEX.includes(index + 1) && <LocalIcon.Gift sx={{ fontSize: '1rem' }} />}
    </Stack>
  ),
  value: index + 1,
}))
interface SelectQuantityProps {
  tagProps?: Omit<BoxProps, 'children'>
  props?: Omit<StackProps, 'children'>
  hideThePopupPrice?: boolean
  priceProps?: Omit<StackProps, 'children'>
  // promotionTextProps?: Omit<TypographyProps, 'children'>
  // hideTheDefaultDiscountText?: boolean
  parentProps?: Omit<StackProps, 'children'>
  hidePriceSale?: boolean
}

export const SelectQuantity = ({
  tagProps,
  props,
  hideThePopupPrice = false,
  priceProps,
  hidePriceSale = false,
  // promotionTextProps,
  // hideTheDefaultDiscountText = false,
  // parentProps
}: SelectQuantityProps) => {
  const t = useTranslations()
  const { productSelected, product, quantity, setQuantity } = useProductDetailV2State()
  const { dataCartPriceRule } = useVoucherStore()
  const { handleOpenSideGuide } = useSizeGuideContext()
  return (
    // <Stack
    //   rowGap={1}
    //   alignItems={'flex-start'}
    //   {...parentProps}
    // >
    <Stack
      position={'relative'}
      gap={2}
      flexWrap={'wrap'}
      flexDirection={'row'}
      alignItems={'flex-end'}
      className="select-quantity-product"
      sx={{
        width: '100%',
      }}
      {...props}
    >
      <Box
        position={'relative'}
        sx={{ display: 'flex', flexDirection: 'column', gap: { xs: 0.5, xxl: 1.5 } }}
        className="select-quantity-wrapper"
      >
        <Box
          component={'span'}
          fontSize={{ xs: '14px', md: '16px' }}
          className="title"
          sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
        >
          <Image src={URL_ICON + 'ic-bags.svg'} alt="Bags Icon" style={{ width: '16px', height: '16px' }} />
          {t('Product.quantity')}:
        </Box>
        <ButtonQuantityV2 quantity={quantity} setQuantity={setQuantity} />
        {/* <Stack
          direction={'row'}
          alignItems={'center'}
          spacing={1}
          onClick={() => handleOpenSideGuide()}
          sx={{
            cursor: 'pointer',
            py: 0.5,
            gap: 0,
            ml: 'auto',
            textTransform: 'uppercase',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          <SquareFootIcon sx={{ width: '0.8em' }} />
          <Typography variant="body2" sx={{ ml: '0 !important' }} fontWeight={600}>
            {t('Footer.bottom.size-guide')}
          </Typography>
        </Stack> */}
      </Box>

      <PriceDisplay
        productSelected={productSelected}
        product={product}
        dataCartPriceRule={dataCartPriceRule}
        tagProps={tagProps}
        containerProps={priceProps}
        hidePriceSale={hidePriceSale}
      />
    </Stack>

    // </Stack>
  )
}

const SelectBox = ({ num, setNum }: { num: number; setNum: (value: number) => void }) => {
  return (
    <Select
      labelId="select-quantity"
      id="select-quantity"
      value={num}
      onChange={(event) => setNum(event.target.value as number)}
      IconComponent={(props) => {
        const { sx: propsSx, ...otherProps } = props
        return (
          <Icon.ArrowDown
            {...otherProps}
            sx={{
              fontSize: { md: '1rem', xs: '0.75rem' },
              ...propsSx, // Merge with any MUI styles
              color: 'inherit!important', // Now this will work
              cursor: 'pointer',
            }}
          />
        )
      }}
      MenuProps={{
        disableScrollLock: true,
        sx: {
          '& .Mui-selected': {
            backgroundColor: '#252422 !important',
            color: 'primary.contrastText',
            borderRadius: '4px',
            margin: '0px 4px',
            '&:hover': { backgroundColor: 'primary.dark' },
          },
        },
      }}
      sx={{
        minWidth: '88px',
        width: 'fit-content',
        borderRadius: '8px',
        color: 'primary.main',
        '& .MuiOutlinedInput-notchedOutline legend': {
          display: 'none',
        },
        padding: '12px',
        '& .MuiSelect-select': {
          padding: '0!important',
          minWidth: '40px',
        },
      }}
      defaultValue={1}
      // hiddenLabel
    >
      {listOption.map((option) => (
        <MenuItem key={option.value} value={option.value}>
          {option.label}
        </MenuItem>
      ))}
    </Select>
  )
}
//#region tag discount
export const TagDiscount = ({
  theDiscountPercent,
  tagProps,
}: {
  theDiscountPercent: number
  tagProps?: Omit<BoxProps, 'children'>
}) => {
  return (
    <Box
      {...tagProps}
      component={'span'}
      sx={{
        verticalAlign: 'top',
        textDecoration: 'none',
        p: '2px 4px',
        borderRadius: '4px',
        backgroundColor: '#17B26A',
        // position: 'absolute',
        top: { xs: '10px', lg: 0 },
        // right: '-4px',
        color: 'white',
        fontSize: '12px',
        fontWeight: 600,
        transform: 'translateX(100%)',
        marginLeft: '0px!important',
        ...tagProps?.sx,
      }}
    >
      -{theDiscountPercent}%
    </Box>
  )
}
